import React from 'react';
import { Badge, Button } from '@mui/material';
import { Message } from '@mui/icons-material';
import { defaultMissingRequirements } from '../../utils/metadata';

import {
    // JobType,
    OfferType,
    MissingRequirementsType
    // OrderType
} from '../../types';
import OfferChatPopup from './OfferChatPopup';

type PropsType = {
    // order: OrderType | JobType;
    offer: OfferType | null;
    orderId: number | null;
    canWrite: boolean;
    refetch: () => void;
    recipient: string;
    missingRequirements?: MissingRequirementsType;
    openInitially?: boolean;
    sx?: any;
};

export default function OfferChatButton({
    // order,
    offer,
    orderId,
    canWrite,
    refetch,
    recipient,
    missingRequirements = defaultMissingRequirements,
    openInitially = false,
    sx
}: PropsType) {
    const [popupIsOpen, setPopupIsOpen] = React.useState(openInitially);

    const onClick = React.useCallback(async (e) => {
        e.stopPropagation();
        setPopupIsOpen(true);
    }, []);

    return (
        <>
            <OfferChatPopup
                open={popupIsOpen}
                id={offer?.id}
                orderId={orderId}
                recipient={recipient}
                canWrite={canWrite}
                missingRequirements={missingRequirements}
                close={() => {
                    setPopupIsOpen(false);
                    refetch();
                }}
            />

            <Badge color="error" badgeContent={offer?.unreadMessageCount ?? 0} sx={sx}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Message />}
                    onClick={onClick}
                    fullWidth
                >
                    {
                        offer?.messageCount && offer?.messageCount > 0
                            ? `${offer?.messageCount} Meddelande${offer?.messageCount !== 1 ? 'n' : ''}`
                            : 'Starta chatt'
                    }
                </Button>
            </Badge>
        </>
    );
}
